import { render, staticRenderFns } from "./BankwirePayment.vue?vue&type=template&id=4670d626&scoped=true"
import script from "./BankwirePayment.vue?vue&type=script&lang=js"
export * from "./BankwirePayment.vue?vue&type=script&lang=js"
import style0 from "./BankwirePayment.vue?vue&type=style&index=0&id=4670d626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670d626",
  null
  
)

export default component.exports